// Temporarily disabled - under maintenance
// import React, { useState, useEffect } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import DashboardLayout from '../components/layout/DashboardLayout';
// import { getUserTickets, getAllTickets, Ticket, PaginationData } from '../services/ticketService';
// import { toast } from 'react-toastify';

import React from 'react';
import DashboardLayout from '../components/layout/DashboardLayout';

const Tickets: React.FC = () => {
  // Temporarily disabled - under maintenance
  // const navigate = useNavigate();
  // const [tickets, setTickets] = useState<Ticket[]>([]);
  // const [loading, setLoading] = useState(true);
  // const [pagination, setPagination] = useState<PaginationData>({
  //   currentPage: 1,
  //   totalPages: 1,
  //   totalItems: 0,
  //   hasNextPage: false,
  //   hasPrevPage: false
  // });

  // // Filters
  // const [filters, setFilters] = useState({
  //   status: '',
  //   department: '',
  //   priority: '',
  //   page: 1
  // });

  // // Check if user is admin
  // const userRole = localStorage.getItem('userRole');
  // const isAdmin = userRole === 'admin';

  // // Filter options
  // const statusOptions = [
  //   { value: '', label: 'همه وضعیت‌ها' },
  //   { value: 'open', label: 'باز' },
  //   { value: 'in_progress', label: 'در حال انجام' },
  //   { value: 'waiting_user', label: 'در انتظار پاسخ کاربر' },
  //   { value: 'waiting_admin', label: 'در انتظار پاسخ ادمین' },
  //   { value: 'resolved', label: 'حل شده' },
  //   { value: 'closed', label: 'بسته شده' }
  // ];

  // const departmentOptions = [
  //   { value: '', label: 'همه بخش‌ها' },
  //   { value: 'IT', label: 'فناوری اطلاعات (IT)' },
  //   { value: 'reception', label: 'پذیرش' },
  //   { value: 'financial', label: 'مالی و حسابداری' },
  //   { value: 'support', label: 'جوابدهی' }
  // ];

  // const priorityOptions = [
  //   { value: '', label: 'همه اولویت‌ها' },
  //   { value: 'low', label: 'کم' },
  //   { value: 'medium', label: 'متوسط' },
  //   { value: 'high', label: 'زیاد' },
  //   { value: 'urgent', label: 'فوری' }
  // ];

  // // Fetch tickets
  // const fetchTickets = async () => {
  //   try {
  //     setLoading(true);
      
  //     const params = {
  //       page: filters.page,
  //       limit: 10,
  //       ...(filters.status && { status: filters.status }),
  //       ...(filters.department && { department: filters.department }),
  //       ...(filters.priority && { priority: filters.priority })
  //     };

  //     const response = isAdmin 
  //       ? await getAllTickets(params)
  //       : await getUserTickets(params);

  //     if (response.success && response.data.tickets && response.data.pagination) {
  //       setTickets(response.data.tickets);
  //       setPagination(response.data.pagination);
  //     }
  //   } catch (error) {

  //     toast.error('خطا در دریافت تیکت‌ها');
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   fetchTickets();
  // }, [filters, isAdmin]);

  // // Handle filter changes
  // const handleFilterChange = (name: string, value: string) => {
  //   setFilters(prev => ({
  //     ...prev,
  //     [name]: value,
  //     page: 1 // Reset to first page when filters change
  //   }));
  // };

  // // Handle page change
  // const handlePageChange = (newPage: number) => {
  //   setFilters(prev => ({
  //     ...prev,
  //     page: newPage
  //   }));
  // };

  // // Get status badge color
  // const getStatusBadgeColor = (status: string) => {
  //   switch (status) {
  //     case 'open':
  //       return 'bg-blue-100 text-blue-800';
  //     case 'in_progress':
  //       return 'bg-yellow-100 text-yellow-800';
  //     case 'waiting_user':
  //       return 'bg-orange-100 text-orange-800';
  //     case 'waiting_admin':
  //       return 'bg-purple-100 text-purple-800';
  //     case 'resolved':
  //       return 'bg-green-100 text-green-800';
  //     case 'closed':
  //       return 'bg-gray-100 text-gray-800';
  //     default:
  //       return 'bg-gray-100 text-gray-800';
  //   }
  // };

  // // Get priority badge color
  // const getPriorityBadgeColor = (priority: string) => {
  //   switch (priority) {
  //     case 'urgent':
  //       return 'bg-red-100 text-red-800';
  //     case 'high':
  //       return 'bg-orange-100 text-orange-800';
  //     case 'medium':
  //       return 'bg-yellow-100 text-yellow-800';
  //     case 'low':
  //       return 'bg-gray-100 text-gray-800';
  //     default:
  //       return 'bg-gray-100 text-gray-800';
  //   }
  // };

  // // Format date
  // const formatDate = (dateString: string) => {
  //   return new Intl.DateTimeFormat('fa-IR', {
  //     year: 'numeric',
  //     month: 'long',
  //     day: 'numeric',
  //     hour: '2-digit',
  //     minute: '2-digit'
  //   }).format(new Date(dateString));
  // };

  return (
    <DashboardLayout>
      <div className="p-4 md:p-6">
        <div className="bg-white rounded-lg shadow-md border border-gray-200 p-8">
          <div className="text-center">
            <div className="text-6xl mb-4">🔧</div>
            <h1 className="text-3xl font-bold text-gray-900 mb-4">در حال تعمیر</h1>
            <p className="text-lg text-gray-600 mb-2">
              بخش تیکت‌ها در حال تعمیر و به‌روزرسانی است
            </p>
            <p className="text-sm text-gray-500">
              لطفاً در زمان دیگری مراجعه کنید
            </p>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );

  // Original code - temporarily commented out
  // return (
  //   <DashboardLayout>
  //     <div className="p-4 md:p-6">
  //       {/* Header */}
  //       <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6">
  //         <div>
  //           <h1 className="text-2xl font-bold text-gray-900 mb-2">
  //             {isAdmin ? 'مدیریت تیکت‌ها' : 'تیکت‌های من'}
  //           </h1>
  //           <p className="text-gray-600">
  //             {isAdmin 
  //               ? 'مشاهده و مدیریت تمام تیکت‌های سیستم'
  //               : 'مشاهده تیکت‌های ثبت شده و ارتباط با پشتیبانی'
  //             }
  //           </p>
  //         </div>
  //         <Link
  //           to="/submit-ticket"
  //           className="mt-4 sm:mt-0 inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
  //         >
  //           <span className="ml-2">+</span>
  //           ثبت تیکت جدید
  //         </Link>
  //       </div>

  //       {/* Filters */}
  //       <div className="bg-white rounded-lg shadow-md border border-gray-200 mb-6">
  //         <div className="p-4">
  //           <h3 className="text-lg font-medium text-gray-900 mb-4">فیلترها</h3>
  //           <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
  //             <div>
  //               <label className="block text-sm font-medium text-gray-700 mb-1">
  //                 وضعیت
  //               </label>
  //               <select
  //                 value={filters.status}
  //                 onChange={(e) => handleFilterChange('status', e.target.value)}
  //                 className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
  //               >
  //                 {statusOptions.map(option => (
  //                   <option key={option.value} value={option.value}>
  //                     {option.label}
  //                   </option>
  //                 ))}
  //               </select>
  //             </div>

  //             <div>
  //               <label className="block text-sm font-medium text-gray-700 mb-1">
  //                 بخش
  //               </label>
  //               <select
  //                 value={filters.department}
  //                 onChange={(e) => handleFilterChange('department', e.target.value)}
  //                 className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
  //               >
  //                 {departmentOptions.map(option => (
  //                   <option key={option.value} value={option.value}>
  //                     {option.label}
  //                   </option>
  //                 ))}
  //               </select>
  //             </div>

  //             <div>
  //               <label className="block text-sm font-medium text-gray-700 mb-1">
  //                 اولویت
  //               </label>
  //               <select
  //                 value={filters.priority}
  //                 onChange={(e) => handleFilterChange('priority', e.target.value)}
  //                 className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
  //               >
  //                 {priorityOptions.map(option => (
  //                   <option key={option.value} value={option.value}>
  //                     {option.label}
  //                   </option>
  //                 ))}
  //               </select>
  //             </div>
  //           </div>
  //         </div>
  //       </div>

  //       {/* Tickets List */}
  //       <div className="bg-white rounded-lg shadow-md border border-gray-200">
  //         {loading ? (
  //           <div className="p-8 text-center">
  //             <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
  //             <p className="mt-2 text-gray-600">در حال بارگذاری...</p>
  //           </div>
  //         ) : tickets.length === 0 ? (
  //           <div className="p-8 text-center">
  //             <div className="text-gray-400 text-6xl mb-4">🎧</div>
  //             <h3 className="text-lg font-medium text-gray-900 mb-2">
  //               هیچ تیکتی یافت نشد
  //             </h3>
  //             <p className="text-gray-600 mb-4">
  //               {isAdmin 
  //                 ? 'هنوز تیکتی در سیستم ثبت نشده است'
  //                 : 'شما هنوز تیکتی ثبت نکرده‌اید'
  //               }
  //             </p>
  //             <Link
  //               to="/submit-ticket"
  //               className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
  //             >
  //               ثبت اولین تیکت
  //             </Link>
  //           </div>
  //         ) : (
  //           <>
  //             {/* Tickets Table */}
  //             <div className="overflow-x-auto">
  //               <table className="min-w-full divide-y divide-gray-200">
  //                 <thead className="bg-gray-50">
  //                   <tr>
  //                     <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
  //                       شناسه
  //                     </th>
  //                     <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
  //                       عنوان
  //                     </th>
  //                     <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
  //                       بخش
  //                     </th>
  //                     <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
  //                       اولویت
  //                     </th>
  //                     <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
  //                       وضعیت
  //                     </th>
  //                     {isAdmin && (
  //                       <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
  //                         کاربر
  //                       </th>
  //                     )}
  //                     <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
  //                       آخرین فعالیت
  //                     </th>
  //                     <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
  //                       عملیات
  //                     </th>
  //                   </tr>
  //                 </thead>
  //                 <tbody className="bg-white divide-y divide-gray-200">
  //                   {tickets.map((ticket) => (
  //                     <tr key={ticket._id} className="hover:bg-gray-50">
  //                       <td className="px-6 py-4 whitespace-nowrap">
  //                         <div className="flex items-center">
  //                           <div className="text-sm font-medium text-gray-900">
  //                             {ticket.displayId || ticket._id.slice(-8)}
  //                           </div>
  //                           {ticket.unreadCount && ticket.unreadCount > 0 && (
  //                             <span className="mr-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
  //                               {ticket.unreadCount}
  //                             </span>
  //                           )}
  //                         </div>
  //                       </td>
  //                       <td className="px-6 py-4">
  //                         <div className="text-sm font-medium text-gray-900">
  //                           {ticket.title}
  //                         </div>
  //                         <div className="text-sm text-gray-500">
  //                           {ticket.ticketNumber}
  //                         </div>
  //                       </td>
  //                       <td className="px-6 py-4 whitespace-nowrap">
  //                         <div className="text-sm text-gray-900">
  //                           {ticket.departmentDisplay}
  //                         </div>
  //                       </td>
  //                       <td className="px-6 py-4 whitespace-nowrap">
  //                         <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getPriorityBadgeColor(ticket.priority)}`}>
  //                           {ticket.priorityDisplay}
  //                         </span>
  //                       </td>
  //                       <td className="px-6 py-4 whitespace-nowrap">
  //                         <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getStatusBadgeColor(ticket.status)}`}>
  //                           {ticket.statusDisplay}
  //                         </span>
  //                       </td>
  //                       {isAdmin && (
  //                         <td className="px-6 py-4 whitespace-nowrap">
  //                           <div className="text-sm text-gray-900">
  //                             {ticket.userId.name} {ticket.userId.lastName}
  //                           </div>
  //                           <div className="text-sm text-gray-500">
  //                             {ticket.userId.mobile}
  //                           </div>
  //                         </td>
  //                       )}
  //                       <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
  //                         {formatDate(ticket.lastActivity)}
  //                       </td>
  //                       <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
  //                         <Link
  //                           to={`/tickets/${ticket._id}`}
  //                           className="text-blue-600 hover:text-blue-900 ml-4"
  //                         >
  //                           مشاهده
  //                         </Link>
  //                       </td>
  //                     </tr>
  //                   ))}
  //                 </tbody>
  //               </table>
  //             </div>

  //             {/* Pagination */}
  //             {pagination.totalPages > 1 && (
  //               <div className="px-6 py-3 border-t border-gray-200">
  //                 <div className="flex items-center justify-between">
  //                   <div className="text-sm text-gray-700">
  //                     نمایش {((pagination.currentPage - 1) * 10) + 1} تا {Math.min(pagination.currentPage * 10, pagination.totalItems)} از {pagination.totalItems} نتیجه
  //                   </div>
  //                   <div className="flex space-x-1 space-x-reverse">
  //                     <button
  //                       onClick={() => handlePageChange(pagination.currentPage - 1)}
  //                       disabled={!pagination.hasPrevPage}
  //                       className="px-3 py-1 text-sm border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
  //                     >
  //                       قبلی
  //                     </button>
  //                     <span className="px-3 py-1 text-sm text-gray-700">
  //                       صفحه {pagination.currentPage} از {pagination.totalPages}
  //                     </span>
  //                     <button
  //                       onClick={() => handlePageChange(pagination.currentPage + 1)}
  //                       disabled={!pagination.hasNextPage}
  //                       className="px-3 py-1 text-sm border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
  //                     >
  //                       بعدی
  //                     </button>
  //                   </div>
  //                 </div>
  //               </div>
  //             )}
  //           </>
  //         )}
  //       </div>
  //     </div>
  //   </DashboardLayout>
  // );
};

export default Tickets;